module.exports = __webpack_public_path__ + "media/images/icons/outlined/group-b727759265be88f4097ef7580f5c06cf.svg";